module.exports = __webpack_public_path__ + "img/giftCertificate.21d38f1c.jpg";